import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const CustomCircularProgress = ({ progressCount, size }) => {
    if (progressCount !== null && (progressCount >= 0 && progressCount <= 100)) {
        return (

            <Box sx={{ position: 'relative', display: 'inline-flex', width: size, height: size }}>
                <CircularProgress
                    variant="determinate"
                    value={100}
                    size={size}
                    sx={{ color: '#e0e0e0', position: 'absolute' }}
                />
                <CircularProgress
                    variant="determinate"
                    value={progressCount ? (progressCount / 100 * 100) : 0}
                    size={size}
                    sx={{ color: 'primary.main' }}
                />
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        variant="caption"
                        component="div"
                        sx={{ color: 'text.secondary', fontWeight: 'bold', fontSize: size * 0.32 }}
                    >
                        {progressCount}
                    </Typography>
                </Box>
            </Box>
        );
    }
};

export default CustomCircularProgress;